import React from 'react';

export const SigmaEmbed = ({ sigmaUrl }: { sigmaUrl: string }) => (
  <div
    style={{
      margin: '-50px -32px 0 -32px',
      height: 'calc(100vh - 128px)',
      paddingTop: '32px',
      paddingLeft: '32px',
      paddingRight: '32px',
    }}
    className="sigma-container"
  >
    {Boolean(sigmaUrl) && (
      <iframe
        style={{
          width: '100%',
          height: '100%',
        }}
        title="Dashboard"
        src={sigmaUrl}
        frameBorder="0"
      ></iframe>
    )}
  </div>
);
